import { render, staticRenderFns } from "./ResumeEducations.vue?vue&type=template&id=16a57a08&"
import script from "./ResumeEducations.vue?vue&type=script&lang=js&"
export * from "./ResumeEducations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports